import { isAmenityType, isStorefrontCategoryId } from './amenities';
import { LEGACY_ALIASES } from '../theme/categoryGlyphs';

/**
 * Returns the canonical glyph key for CategoryGlyph / buildMarkerSvg.
 * Single source of truth so map markers and list/detail surfaces never drift.
 *   - amenity types  → type itself ('atm', 'first_aid', 'restroom', 'stage')
 *   - storefront category → 'storefront' (brownstone)
 *   - information category (and its legacy aliases) → 'information'
 *   - everything else → 'tent'
 */
export function resolveGlyphKey(type: string, categoryId: string): string {
  if (isAmenityType(type)) return type;
  const catLower = categoryId.toLowerCase();
  if (isStorefrontCategoryId(catLower)) return 'storefront';
  if (
    catLower === 'information' ||
    catLower === 'info' ||
    LEGACY_ALIASES[catLower] === 'information'
  ) {
    return 'information';
  }
  return 'tent';
}
